import { Orientation } from '@/modules'
import { Signal } from 'typed-signals'

export default {
    orientationChanged: new Signal<(orientation: Orientation) => void>(),
}
